import React, { useState, useEffect } from 'react';
import TimePicker from '../../../components/utils/timepicker';
import Select from "react-select";
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes, FaTrashAlt, FaPlus} from 'react-icons/fa';

const AgendaUnidadeModal = ({ onClose }) => {
    const [gestoraSelecionada, setGestoraSelecionada] = useState(null);
    const [unidadeSelecionada, setUnidadeSelecionada] = useState(null);
    const [gestorasOptions, setGestorasOptions] = useState([]);
    const [unidadesOptions, setUnidadesOptions] = useState([]);
    const [horariosUnidade, setHorariosUnidade] = useState([]);
    const [userData, setUserData] = useState(null);

    const convertHourToDate = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
        return date;
    };

    const convertDateToHour = (date) => {
        if (!date) return '';
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            whiteSpace: "pre-line",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }),
    };

    useEffect(() => {
        const fetchUserDataAndPreload = async () => {
            let user = null;
            try {
                const response = await api.get('/me');
                user = response.data;
                setUserData(user);
                
                await carregarGestoras();
                
                if (user.gestora_designacao_id) {
                    const gestoraOption = {
                        value: user.gestora_designacao_id,
                        label: user.gestora?.nome || 'Gestora'
                    };
                    setGestoraSelecionada(gestoraOption);
                    await carregarUnidades(user.gestora_designacao_id);
                    
                    if (user.unidade_designacao_id) {
                        const unidadeOption = {
                            value: user.unidade_designacao_id,
                            label: user.unidade?.nome || 'Unidade'
                        };
                        setUnidadeSelecionada(unidadeOption);
                        await carregarHorariosUnidade(user.unidade_designacao_id);
                    }
                }
            } catch (error) {
                Swal.fire('Erro', 'Erro ao carregar dados do usuário', 'error');
            }
            
            if (!user?.unidade_designacao_id) {
                const horarioVazio = {
                    id: `temp_${new Date().getTime()}`,
                    hora_inicio: null,
                    hora_termino: null,
                    dias_semana: {
                        segunda: false,
                        terca: false,
                        quarta: false,
                        quinta: false,
                        sexta: false,
                        sabado: false,
                        domingo: false
                    }
                };
                setHorariosUnidade([horarioVazio]);
            }
        };
        
        fetchUserDataAndPreload();
    }, []);

    const carregarHorariosUnidade = async (unidadeId) => {
        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await api.get(`/configuracao-agenda-unidade/unidade/${unidadeId}`);

            const horariosData = response.data?.data || response.data;

            if (horariosData && Array.isArray(horariosData) && horariosData.length > 0) {
                const horariosConvertidos = converterHorariosPadrao(horariosData);
                setHorariosUnidade(horariosConvertidos);
            } else {
                const horarioVazio = {
                    id: `temp_${new Date().getTime()}`,
                    hora_inicio: null,
                    hora_termino: null,
                    dias_semana: {
                        segunda: false,
                        terca: false,
                        quarta: false,
                        quinta: false,
                        sexta: false,
                        sabado: false,
                        domingo: false
                    }
                };
                setHorariosUnidade([horarioVazio]);
            }
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar horários da unidade', 'error');
            const horarioVazio = {
                id: `temp_${new Date().getTime()}`,
                hora_inicio: '',
                hora_termino: '',
                dias_semana: {
                    segunda: false,
                    terca: false,
                    quarta: false,
                    quinta: false,
                    sexta: false,
                    sabado: false,
                    domingo: false
                }
            };
            setHorariosUnidade([horarioVazio]);
        } finally {
            Swal.close();
        }
    };

    const converterHorariosPadrao = (horariosApi) => {
        if (!Array.isArray(horariosApi)) return [];

        const horariosAgrupados = {};

        horariosApi.forEach((horario) => {
            const horaInicio = horario.hora_inicio ? horario.hora_inicio.substring(0, 5) : '';
            const horaTermino = horario.hora_termino ? horario.hora_termino.substring(0, 5) : '';
            const chave = `${horaInicio}-${horaTermino}`;

            const horaInicioDate = horaInicio ? convertHourToDate(horaInicio) : null;
            const horaTerminoDate = horaTermino ? convertHourToDate(horaTermino) : null;

            if (!horariosAgrupados[chave]) {
                horariosAgrupados[chave] = {
                    id: `temp_${new Date().getTime()}_${Math.random()}`,
                    unidade_id: horario.unidade_id || '',
                    hora_inicio: horaInicioDate,
                    hora_termino: horaTerminoDate,
                    dias_semana: {
                        segunda: false, terca: false, quarta: false, quinta: false, sexta: false, sabado: false, domingo: false
                    },
                    horariosOriginais: []
                };
            }

            const diasMap = {
                0: 'domingo',
                1: 'segunda',
                2: 'terca',
                3: 'quarta',
                4: 'quinta',
                5: 'sexta',
                6: 'sabado'
            };

            const diaSemana = diasMap[horario.dia_semana];
            if (diaSemana) {
                horariosAgrupados[chave].dias_semana[diaSemana] = true;
            }

            horariosAgrupados[chave].horariosOriginais.push(horario);
        });

        return Object.values(horariosAgrupados);
    };

    const carregarGestoras = async () => {
        try {
            const response = await api.get('/gestoras?page=1&limit=200');
            const gestoras = response.data.gestoras.map(gestora => ({
                value: gestora.id,
                label: gestora.nome
            }));
            setGestorasOptions(gestoras);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar gestoras', 'error');
        }
    };
    
    const carregarUnidades = async (gestoraId) => {
        try {
            const response = await api.get(`/gestoras/${gestoraId}/unidades?page=1&limit=200`);
            const unidades = response.data.unidades.map(unidade => ({
                value: unidade.id,
                label: unidade.nome
            }));
            setUnidadesOptions(unidades);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar unidades', 'error');
        }
    };
    
    const handleSelectGestora = (e) => {
        const gestoraId = e.target.value;
        const gestora = gestorasOptions.find(g => g.value == gestoraId);
        setGestoraSelecionada(gestora);
        setUnidadeSelecionada(null);
        setUnidadesOptions([]);
        
        if (gestoraId) {
            carregarUnidades(gestoraId);
        }
        
        const horarioVazio = {
            id: `temp_${new Date().getTime()}`,
            hora_inicio: '',
            hora_termino: '',
            dias_semana: {
                segunda: false,
                terca: false,
                quarta: false,
                quinta: false,
                sexta: false,
                sabado: false,
                domingo: false
            }
        };
        setHorariosUnidade([horarioVazio]);
    };

    const handleSelectUnidade = (e) => {
        const unidadeId = e.target.value;
        const unidade = unidadesOptions.find(u => u.value == unidadeId);
        setUnidadeSelecionada(unidade);
        
        if (unidadeId) {
            carregarHorariosUnidade(unidadeId);
        } else {
            const horarioVazio = {
                id: `temp_${new Date().getTime()}`,
                hora_inicio: '',
                hora_termino: '',
                dias_semana: {
                    segunda: false,
                    terca: false,
                    quarta: false,
                    quinta: false,
                    sexta: false,
                    sabado: false,
                    domingo: false
                }
            };
            setHorariosUnidade([horarioVazio]);
        }
    };

    const handleAdicionarHorario = () => {
        if (!unidadeSelecionada?.value) {
            Swal.fire('Atenção', 'Selecione uma unidade primeiro', 'warning');
            return;
        }

        const novoHorario = {
            id: `temp_${new Date().getTime()}`,
            unidade_id: unidadeSelecionada.value,
            hora_inicio: null,
            hora_termino: null,
            dias_semana: {
                segunda: false,
                terca: false,
                quarta: false,
                quinta: false,
                sexta: false,
                sabado: false,
                domingo: false
            }
        };

        setHorariosUnidade(prev => [...prev, novoHorario]);
    };

    const handleRemoverHorario = (id) => {
        setHorariosUnidade(prev => prev.filter((horario) => horario.id !== id));
    };

    const handleChangeHorario = (id, field, value) => {
        setHorariosUnidade(prev =>
            prev.map((horario) =>
                horario.id === id ? { ...horario, [field]: value } : horario
            )
        );
    };

    const handleChangeDiaSemana = (horarioId, dia, checked) => {
        setHorariosUnidade(prev =>
            prev.map((horario) =>
                horario.id === horarioId
                    ? {
                        ...horario,
                        dias_semana: {
                            ...horario.dias_semana,
                            [dia]: checked
                        }
                    }
                    : horario
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!unidadeSelecionada?.value) {
            Swal.fire('Erro', 'Selecione uma unidade', 'error');
            return;
        }

        const horariosValidos = horariosUnidade.filter(horario => {
            const temHorario = horario.hora_inicio && horario.hora_termino;
            const temDias = Object.values(horario.dias_semana).some(dia => dia === true);
            return temHorario && temDias;
        });

        if (horariosValidos.length === 0) {
            Swal.fire('Erro', 'Configure pelo menos um horário com dias da semana selecionados', 'error');
            return;
        }

        const horariosFormatados = horariosUnidade.map(horario => {
            const diasSelecionados = [];
            if (horario.dias_semana.domingo) diasSelecionados.push(0);
            if (horario.dias_semana.segunda) diasSelecionados.push(1);
            if (horario.dias_semana.terca) diasSelecionados.push(2);
            if (horario.dias_semana.quarta) diasSelecionados.push(3);
            if (horario.dias_semana.quinta) diasSelecionados.push(4);
            if (horario.dias_semana.sexta) diasSelecionados.push(5);
            if (horario.dias_semana.sabado) diasSelecionados.push(6);

            return diasSelecionados.map(dia => {
                const horarioOriginal = horario.horariosOriginais?.find(h => h.dia_semana === dia);

                return {
                    ...(horarioOriginal && !horarioOriginal.id.toString().startsWith('temp_') ? { id: horarioOriginal.id } : {}),
                    unidade_id: unidadeSelecionada.value,
                    dia_semana: dia,
                    hora_inicio: convertDateToHour(horario.hora_inicio),
                    hora_termino: convertDateToHour(horario.hora_termino)
                };
            });
        }).flat().filter(horario => horario.hora_inicio && horario.hora_termino);

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post('/configuracao-agenda-unidade/multiplos', {
                unidade_id: unidadeSelecionada.value,
                horarios: horariosFormatados
            });

            Swal.fire('Sucesso', 'Horários da unidade salvos com sucesso!', 'success');
            //carregarHorariosUnidade(unidadeSelecionada.value);
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response?.data?.message || 'Erro ao salvar horários da unidade'}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">
                            Configuração de Agenda da Unidade
                        </h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row mt-3">
                                <div className="col-lg-6 col-md-12">
                                    <label className="form-label fw-bold">Gestora</label>
                                    <select
                                        className="form-control"
                                        value={gestoraSelecionada?.value || ''}
                                        onChange={handleSelectGestora}
                                        disabled={userData?.gestora_designacao_id}
                                    >
                                        <option value="" hidden>Selecione uma gestora...</option>
                                        {gestorasOptions.map(gestora => (
                                            <option key={gestora.value} value={gestora.value}>
                                                {gestora.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-6 col-md-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <select
                                        className="form-control"
                                        value={unidadeSelecionada?.value || ''}
                                        onChange={handleSelectUnidade}
                                        disabled={!gestoraSelecionada?.value || userData?.unidade_designacao_id}
                                    >
                                        <option value="" hidden>
                                            {!gestoraSelecionada?.value ? "Selecione uma gestora primeiro" : "Selecione uma unidade..."}
                                        </option>
                                        {unidadesOptions.map(unidade => (
                                            <option key={unidade.value} value={unidade.value}>
                                                {unidade.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {unidadeSelecionada && (
                                <>
                                    <div className="row mt-4">
                                        <div className="col-12">
                                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-end mb-3">
                                                <div>
                                                    <h6 className="fw-bold mb-1">Horários de Funcionamento</h6>
                                                    <p className="text-muted mb-2 mb-lg-0">Configure os horários de funcionamento da unidade</p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary align-self-end mt-2 mt-lg-0"
                                                    onClick={handleAdicionarHorario}
                                                >
                                                    <FaPlus /> Adicionar Horário
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {horariosUnidade.length > 0 && (
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead className="table-custom-primary">
                                                            <tr>
                                                                <th className="text-nowrap">Horário de Início</th>
                                                                <th className="text-nowrap">Horário de Término</th>
                                                                <th>Dias da Semana</th>
                                                                <th className="text-center">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {horariosUnidade.map((horario) => (
                                                                <tr key={horario.id}>
                                                                    <td>
                                                                        <TimePicker
                                                                            value={horario.hora_inicio}
                                                                            onChange={(time) => handleChangeHorario(horario.id, 'hora_inicio', time)}
                                                                            timeIntervals={15}
                                                                            className="form-control"
                                                                            strategy="fixed"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <TimePicker
                                                                            value={horario.hora_termino}
                                                                            onChange={(time) => handleChangeHorario(horario.id, 'hora_termino', time)}
                                                                            timeIntervals={15}
                                                                            className="form-control"
                                                                            strategy="fixed"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex gap-2 d-lg-flex flex-lg-wrap flex-nowrap">
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.segunda}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'segunda', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Seg</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.terca}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'terca', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Ter</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.quarta}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'quarta', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Qua</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.quinta}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'quinta', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Qui</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.sexta}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'sexta', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Sex</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.sabado}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'sabado', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Sáb</label>
                                                                            </div>
                                                                            <div className="form-check form-check-inline">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={horario.dias_semana.domingo}
                                                                                    onChange={(e) => handleChangeDiaSemana(horario.id, 'domingo', e.target.checked)}
                                                                                />
                                                                                <label className="form-check-label">Dom</label>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-custom-secondary btn-sm"
                                                                            onClick={() => handleRemoverHorario(horario.id)}
                                                                        >
                                                                            <FaTrashAlt />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button
                                    className="btn btn-custom-primary ms-3"
                                    type="submit"
                                    disabled={!unidadeSelecionada}
                                    onClick={handleSubmit}
                                >
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgendaUnidadeModal;
